<canvas aria-hidden="true" #canvas></canvas>
